export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 4c1.196 0 2.42.21 3.376.835.23.15.438.322.624.514.186-.192.394-.363.624-.514C13.579 4.21 14.804 4 16 4h4a1 1 0 011 1v13.09a1 1 0 01-1 1h-4c-1.03 0-1.809.17-2.3.475-.414.258-.7.655-.7 1.435h-2c0-.78-.286-1.177-.7-1.435-.491-.306-1.27-.474-2.3-.474H4a1 1 0 01-1-1V5l.005-.103A1 1 0 014 4h4zM5 17.09h3c1.036 0 2.106.142 3 .58V8c0-.785-.292-1.212-.72-1.492C9.788 6.186 9.012 6 8 6H5v11.09zM16 6c-1.012 0-1.788.186-2.28.508-.428.28-.72.707-.72 1.492v9.67c.894-.439 1.963-.58 3-.58h3V6h-3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};